var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAkarIconsVscodeFill = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2184_1459)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2184_1459",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2184_1459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.228015 8.37003C0.228015 8.37003 -0.355985 7.94303 0.345015 7.37503L1.98002 5.89703C1.98002 5.89703 2.44701 5.40003 2.94201 5.83303L18.023 17.375V22.909C18.023 22.909 18.016 23.779 16.913 23.683L0.227015 8.36903L0.228015 8.37003Z",
    fill: "#C89AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11601 11.937L0.22801 15.509C0.22801 15.509 -0.17199 15.809 0.22801 16.346L2.03301 18.006C2.03301 18.006 2.46201 18.471 3.09501 17.941L7.21601 14.783L4.11601 11.937ZM10.94 11.966L18.07 6.46403L18.023 0.959031C18.023 0.959031 17.718 -0.242969 16.703 0.383031L7.21601 9.11003L10.94 11.966Z",
    fill: "#C89AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.912 23.69C17.326 24.118 17.828 23.978 17.828 23.978L23.384 21.211C24.095 20.721 23.995 20.113 23.995 20.113V3.58805C23.995 2.86205 23.26 2.61105 23.26 2.61105L18.444 0.264048C17.392 -0.392952 16.703 0.383048 16.703 0.383048C16.703 0.383048 17.589 -0.261952 18.023 0.959048V22.809C18.023 22.959 17.991 23.106 17.928 23.239C17.801 23.498 17.526 23.739 16.866 23.639L16.912 23.69Z",
    fill: "#C89AF9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2184_1459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAkarIconsVscodeFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/akar-icons_vscode-fill.b0db1eb654d9dd9db2785657a42228e7.svg";